module.exports = __webpack_public_path__ + "img/l5.0cea34f5.png";